import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "footer-container",
  class: "back-white flex j-evenly align-c"
}
const _hoisted_2 = {
  id: "footer-links",
  class: "footer-item flex j-between"
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"footer-item flex align-c\"><img class=\"footer-icon\" src=\"/icons/CARE envelope.svg\" alt=\"envelope\"><a class=\"t-no-decoration\" href=\"mailto:info@CareBehavioralHealth.com\">info@CareBehavioralHealth.com</a></div><div class=\"footer-item flex align-c\"><img class=\"footer-icon\" src=\"/icons/phone-1.svg\" alt=\"phone\"><a class=\"t-no-decoration\" href=\"tel:+17025619192\">(702) 561-9192</a></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/about",
        class: "text-link-blue"
      }, {
        default: _withCtx(() => [
          _createTextVNode("About")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/services",
        class: "text-link-blue"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Services")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/resources",
        class: "text-link-blue"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Resources")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/contact",
        class: "text-link-blue"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Contact")
        ]),
        _: 1
      })
    ]),
    _hoisted_3
  ]))
}